/* people: die Seiten „Personen“ und das Bearbeiten eines Mandanten (W3,
 * 2026-09-30). Dieselben Schlüssel wie en/people.ts. */
export default {
  people: {
    title: 'Personen',
    subtitle:
      'Alle, die sich im Arbeitsbereich der Kanzlei anmelden können, und was jede Person sieht.',
    add: 'Person hinzufügen',
    back: 'Zurück zu den Personen',
    emptyTitle: 'Noch niemand hier',
    empty:
      'Fügen Sie eine Kollegin oder einen Kollegen hinzu, oder eine Person beim Mandanten, die ihre Verfahren verfolgen soll.',
    group: {
      firm_main: 'Hauptkonto',
      firm_manager: 'Anwältinnen und Anwälte der Kanzlei',
      client_viewer: 'Personen bei Mandanten',
    },
    groupSub: {
      firm_main: 'Sieht und ändert alles und kann als Einziges Personen hinzufügen.',
      firm_manager: 'Arbeiten an den Mandanten und Marken, die ihnen zugewiesen sind.',
      client_viewer:
        'Lesen die offenen Verfahren ihres eigenen Unternehmens. Treffer sehen sie nie.',
    },
  },

  person: {
    newTitle: 'Neue Person',
    newSub:
      'Wählen Sie, wer die Person ist und was sie sehen darf. Ob sie jetzt eine Einladung bekommt, entscheiden Sie gesondert.',
    kind: {
      firm_main: 'Hauptkonto',
      firm_manager: 'Anwältin oder Anwalt der Kanzlei',
      client_viewer: 'Person beim Mandanten',
    },
    kindHint: {
      firm_manager:
        'Kann an den Mandanten und Marken arbeiten, die Sie zuweisen: Treffer, Verfahren, Dokumente.',
      client_viewer:
        'Kann nur die offenen Verfahren der zugewiesenen Unternehmen lesen. Kann nichts ändern.',
    },
    role: {
      senior_partner: 'Seniorpartner',
      partner: 'Partner',
      senior_associate: 'Senior Associate',
      counsel: 'Counsel',
      associate: 'Associate',
    },
    status: {
      off: 'Deaktiviert',
      notInvited: 'Noch nicht eingeladen',
      invited: 'Eingeladen am {date}',
      expired: 'Einladung abgelaufen',
    },
    form: {
      title: 'Wer die Person ist',
      sub: 'Der Name, wie Kollegen ihn sehen, und die Sprache ihrer E-Mails.',
      kind: 'Kontoart',
      name: 'Vollständiger Name',
      nameRequired: 'Geben Sie den Namen ein',
      email: 'E-Mail-Adresse',
      emailInvalid: 'Geben Sie eine gültige E-Mail-Adresse ein',
      emailHint:
        'Mit dieser Adresse meldet sich die Person an. Sie kann später nicht geändert werden.',
      role: 'Position in der Kanzlei',
      noRole: 'Nicht angegeben',
      language: 'Sprache',
      languageDefault: 'Nicht gewählt (Englisch)',
      languageHint: 'Für ihre E-Mails. Nach der Anmeldung kann die Person sie selbst ändern.',
    },
    access: {
      title: 'Was die Person sehen darf',
      sub: {
        firm_manager:
          'Ganze Unternehmen oder nur einige Marken eines Unternehmens. Sonst ist nichts sichtbar.',
        client_viewer:
          'Die Unternehmen, deren offene Verfahren die Person lesen darf. Mindestens eines ist nötig.',
      },
      whole: 'Das ganze Unternehmen',
      some: 'Nur einige Marken',
      howMuch: 'Wie viel von diesem Unternehmen',
      noMarks: 'Dieses Unternehmen hat noch keine Marken.',
      chooseMarks: 'Wählen Sie mindestens eine Marke oder das ganze Unternehmen.',
      search: 'Mandantenunternehmen suchen…',
      dropPending: '{name} nicht hinzufügen',
      viewerNeedsOne: 'Fügen Sie mindestens ein Unternehmen hinzu: sonst sähe die Person nichts.',
      give: 'Diesen Zugang geben',
      given: 'Zugang gegeben',
      remove: 'Entfernen',
      removeTitle: 'Zugang zu {what} entfernen?',
      removeBody: 'Die Person sieht es sofort nicht mehr. Sonst ändert sich nichts.',
      noneYet: 'Die Person sieht noch nichts. Fügen Sie unten ein Unternehmen hinzu.',
      mainSeesAll: 'Das Hauptkonto sieht die ganze Kanzlei. Hier gibt es nichts zu wählen.',
      wholeFirm: 'Die ganze Kanzlei',
      none: 'Noch nichts',
      clients: '{n} Unternehmen | {n} Unternehmen',
      someMarks: '{name}: {n} Marke | {name}: {n} Marken',
    },
    invite: {
      title: 'Einladung',
      sub: 'Eine E-Mail mit einem Link, um ein Passwort zu wählen. Der Link funktioniert einmal, 7 Tage lang.',
      now: 'Jetzt eine Einladung per E-Mail senden',
      send: 'Einladung senden',
      again: 'Neue Einladung senden',
      confirmTitle: 'Einladung an {email} senden?',
      body: 'Die Person erhält einen Link, um ein Passwort zu wählen und sich anzumelden.',
      replaces:
        'Die Person erhält einen neuen Link, um ein Passwort zu wählen. Der früher gesendete Link funktioniert nicht mehr.',
      sent: 'An {email} gesendet.',
      done: 'Einladung gesendet',
      failed: 'Die Einladung wurde nicht gesendet',
      hasPassword:
        'Die Person hat ein Passwort und kann sich anmelden. Mit einer neuen Einladung kann sie ein anderes wählen.',
      waiting: 'Eingeladen am {sent}. Der Link gilt bis {until}.',
      lapsed: 'Eingeladen am {sent}, aber der Link ist ungenutzt abgelaufen.',
      never: 'Noch nicht eingeladen: ohne Einladung kann sich die Person nicht anmelden.',
    },
    account: {
      title: 'Das Konto',
      sub: 'Beim Deaktivieren bleibt alles erhalten, was die Person getan hat; Löschen entfernt das Konto selbst.',
    },
    off: {
      action: 'Deaktivieren',
      undo: 'Wieder aktivieren',
      confirmTitle: '{name} deaktivieren?',
      body: 'Die Person wird abgemeldet und kann sich nicht anmelden, bis Sie sie wieder aktivieren. Was sie getan hat, bleibt.',
    },
    delete: {
      action: 'Löschen',
      confirmTitle: '{name} löschen?',
      body: 'Das Konto und seine Zugänge werden entfernt und können nicht wiederhergestellt werden. Verfahren, die der Person zugewiesen waren, sind danach niemandem zugewiesen; die Aufzeichnung ihres Handelns bleibt.',
      done: '{name} gelöscht',
    },
    create: 'Person anlegen',
    save: 'Speichern',
    saved: 'Gespeichert',
    created: 'Person hinzugefügt',
    createdSub: 'Es wurde keine E-Mail gesendet. Senden Sie die Einladung, wenn Sie so weit sind.',
    createdNoInvite: 'Person hinzugefügt, aber die Einladung wurde nicht gesendet',
    failed: 'Das hat nicht geklappt',
    emailTaken: 'Mit dieser E-Mail-Adresse gibt es bereits ein Konto.',
    summary: 'Kurz gesagt',
  },

  editClient: {
    crumb: 'Bearbeiten',
    title: 'Mandant bearbeiten',
    subtitle: 'Ändern Sie, was zu {name} gespeichert ist. Nur geänderte Felder werden gespeichert.',
    save: 'Änderungen speichern',
    saving: 'Wird gespeichert…',
    saved: 'Änderungen gespeichert',
    failed: 'Die Änderungen wurden nicht gespeichert',
    notSaved: 'Nichts wird gespeichert, bevor Sie „Änderungen speichern“ drücken.',
    delete: {
      title: 'Diesen Mandanten löschen',
      sub: 'Entfernt das Unternehmen mit seiner {n} Marke, deren Dokumenten und Treffern sowie allen Zugängen dazu. | Entfernt das Unternehmen mit seinen {n} Marken, deren Dokumenten und Treffern sowie allen Zugängen dazu.',
      action: 'Mandant löschen',
      confirmTitle: '{name} löschen?',
      body: 'Seine {n} Marke, deren Dokumente und Treffer sowie alle Zugänge zum Unternehmen werden entfernt. Das lässt sich nicht rückgängig machen. | Seine {n} Marken, deren Dokumente und Treffer sowie alle Zugänge zum Unternehmen werden entfernt. Das lässt sich nicht rückgängig machen.',
      done: '{name} gelöscht',
      failed: 'Der Mandant wurde nicht gelöscht',
      hasCases:
        'Es gibt Widerspruchsverfahren. Löschen Sie diese zuerst auf der Seite „Widersprüche“.',
    },
  },
}
